<script setup lang="ts">
const {
  speed = -2,
  clampTop = false,
  desktopOnly = false,
  rotate = false,
} = defineProps<{
  speed?: number
  clampTop?: boolean
  desktopOnly?: boolean
  rotate?: boolean
}>()

const $container = useTemplateRef('$container')

const { height: innerHeight, width: innerWidth } = useWindowSize()
const { y, height } = useElementBounding($container)
const { y: scrollY } = useScroll($container)

const targetIsVisible = useElementVisibility($container, {
  rootMargin: '400px 0px 400px 0px',
})

const progress = computed(() => {
  if (!targetIsVisible.value) return 0
  if (desktopOnly && innerWidth.value < 900) return 0
  if (clampTop) return 0
  if (import.meta.server) return 0
  return (y.value + height.value / 2 - innerHeight.value / 2) / (innerHeight.value / 2)
})

const translateY = computed(() => {
  if (!targetIsVisible.value) return 0
  return clampTop ? scrollY.value / speed / 10 : progress.value * speed * 3
})
</script>

<template>
  <div ref="$container">
    <ClientOnly v-if="!clampTop">
      <div
        class="transition-transform duration-100"
        :style="{
          transform: `translateY(${translateY}vmin) rotate(${rotate ? translateY * 2 : 0}deg)`,
          transformOrigin: 'center',
          transitionTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)',
        }"
      >
        <slot />
      </div>
    </ClientOnly>
    <div
      v-else
      class="transition-transform duration-100"
      :style="{
        transform: `translateY(${translateY}vmin) rotate(${rotate ? translateY * 2 : 0}deg)`,
        transformOrigin: 'center',
        transitionTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)',
      }"
    >
      <slot />
    </div>
  </div>
</template>
